export const packages = [
	{
		id: 1,
		name: 'العادية',
		price: [
			{ type: 'شهريا', money: 399 },
			{ type: 'سنويا', money: 299 },
		],
		features: [
			'طلبات غير محدودة',
			'علامات تجارية غير محدودة',
			'عدد غير محدود من المستخدمين',
			'صور مخزون غير محدود',
			'إيقاف مؤقت أو إلغاء في أي وقت',
		],
		special: false,
	},
	{
		id: 2,
		name: 'الإحترافية',
		price: [
			{ type: 'شهريا', money: 399 },
			{ type: 'سنويا', money: 299 },
		],
		features: [
			'طلبات غير محدودة',
			'علامات تجارية غير محدودة',
			'عدد غير محدود من المستخدمين',
			'صور مخزون غير محدود',
			'إيقاف مؤقت أو إلغاء في أي وقت',
		],
		special: true,
	},
	{
		id: 3,
		name: 'الذهبية',
		price: [
			{ type: 'شهريا', money: 399 },
			{ type: 'سنويا', money: 299 },
		],
		features: [
			'طلبات غير محدودة',
			'علامات تجارية غير محدودة',
			'عدد غير محدود من المستخدمين',
			'صور مخزون غير محدود',
			'إيقاف مؤقت أو إلغاء في أي وقت',
		],
		special: false,
	},
];
